import { READER_API_ENDPOINT } from 'config/vars'

export const REGISTER_AUDIO_BOOKS = `${READER_API_ENDPOINT}/register_audio_books`
